import { render } from "./SystemThemeUploadForm.vue?vue&type=template&id=283d2601&ts=true"
import script from "./SystemThemeUploadForm.vue?vue&type=script&lang=ts"
export * from "./SystemThemeUploadForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__